import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import ClickAwayListener from "react-click-away-listener";
import { HomeOutlined, LogoutOutlined, MenuUnfoldOutlined, SketchOutlined } from "@ant-design/icons";
import { WebLogo } from "../utils/Images";
import { authlogout } from "../store/Authentication";
import { useDispatch } from "react-redux";

export default function Sidebar({ dir }) {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false); // Sidebar state for small screens
  const location = useLocation();
  const path = location.pathname;
  const toggleSidebar = () => setIsOpen(!isOpen); // Toggle function

  const handleClickAway = () => {
    setIsOpen(false)
  }

  const SidebarData = [
    {
      name: "Home",
      path: "/landing/home",
      logo: <HomeOutlined />,
    },
    {
      name: "Subscription",
      path: "/landing/manage-subscription",
      logo: <SketchOutlined />,
    },
    {
      name: "Logout",
      path: "/",
      logo: <LogoutOutlined />,
    },
  ];

  const handleLogout = (path) => {
    navigate(path);
    dispatch(authlogout([]))
  }

  return (
    <SidebarMainWrapper>
      {/* Sidebar Toggle Icon */}
      <ClickAwayListener onClickAway={handleClickAway}>
        <SidebarToggle onClick={toggleSidebar} path={path} isOpen={isOpen}>
          <MenuUnfoldOutlined />
        </SidebarToggle>
      </ClickAwayListener>

      {/* Sidebar Container */}
      <SidebarContainer dir={dir} isOpen={isOpen}>
        <img src={WebLogo} alt="" className="webLogo" onClick={() => navigate("/landing/dashboard")} />
        <InnerContainer>
          <SidebarMenu>
            {SidebarData.map((val) => {
              const active = window.location.pathname === val.path;
              return (
                <NavItem
                  key={val.name}
                  onClick={() => val?.name == "Logout" ? handleLogout(val?.path) : navigate(val.path)}
                  active={active}
                >
                  {val.logo}
                  <p>
                    {val?.name}
                  </p>
                </NavItem>
              );
            })}
          </SidebarMenu>
        </InnerContainer>
      </SidebarContainer>
    </SidebarMainWrapper>
  );
}

const SidebarToggle = styled.div`
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 20;
  font-size: 24px;
  cursor: pointer;
  display: none;

  .anticon{
    filter:${({ path, isOpen }) => isOpen ? "invert(0)" : path == "/landing/home" ? "invert(1)" : "invert(0)"}
  }

  @media (max-width: 1245px) {
    display: block;
  }
`;

const SidebarContainer = styled.div`
  z-index:9;
  height: 100vh;
  width: ${({ isOpen }) => (isOpen ? "250px" : "0")};
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.25);
  transition: width 0.3s ease;
  position: fixed;
  top: 0;
  left: ${({ dir }) => (dir === "ltr" ? "0" : "auto")};
  right: ${({ dir }) => (dir === "rtl" ? "0" : "auto")};
  text-align:center;

  @media (min-width: 1245px) {
    width: 19%; /* Static width for larger screens */
  }
  .webLogo{
    cursor:pointer;
    margin-top:30px;
    filter:invert(1);
    width:100px;
    height:54px;
  }
`;

const InnerContainer = styled.div`
  padding: 20px;

  @media (max-width: 2400px) {
    padding-top:30px;
  }
  
  @media (max-width: 1245px) {
    padding-top:70px;
  }
`;

const SidebarMenu = styled.div`
  display: flex;
  flex-direction: column;
`;

const NavItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  color: ${({ active }) => (active ? "#fff" : "#000")};
  background: ${({ active }) => (active ? "#0DA982" : "transparent")};
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 10px;
  transition: all 0.3s ease;

  p {
    margin: 0 0 0 10px;
  }

  &:hover {
    background: #0DA982;
    color: #fff;
  }

  svg{
    width:20px;
    height:20px;
  }
`;

const SidebarMainWrapper = styled.div`
    display: none;
    @media (max-width: 700px){
        display: inline;
    }
`
